import chroma from 'chroma-js'
import { onlyNumbers } from 'core/helpers/format'

export const GOOGLE_MAPS_KEY = 'AIzaSyDjHVVjITht0W2AaxINWLp0xP_pLrpD918'

export const getAddress = cep =>
	fetch(`https://viacep.com.br/ws/${onlyNumbers(cep)}/json`).then(r => r.json())

export const colorizedStyles = {
	control: styles => ({ ...styles, backgroundColor: 'white' }),
	option: (styles, { data, isDisabled, isFocused, isSelected }) => {
		const color = chroma(data.color)

		let backgroundColor = null
		let styleColor = data.color

		if (isSelected) {
			backgroundColor = data.color
			styleColor = chroma.contrast(color, 'white') > 2 ? 'white' : 'black'
		} else if (isFocused) {
			backgroundColor = color.alpha(0.1).css()
		}

		if (isDisabled) {
			styleColor = '#ccc'
		}

		return {
			...styles,
			backgroundColor,
			color: styleColor,
			cursor: isDisabled ? 'not-allowed' : 'default',

			':active': {
				...styles[':active'],
				backgroundColor: !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
			},
		}
	},
	multiValue: (styles, { data }) => {
		const color = chroma(data.color)
		return {
			...styles,
			backgroundColor: color.alpha(0.1).css(),
		}
	},
	multiValueLabel: (styles, { data }) => ({
		...styles,
		color: data.color,
	}),
	multiValueRemove: (styles, { data }) => ({
		...styles,
		color: data.color,
		':hover': {
			backgroundColor: data.color,
			color: 'white',
		},
	}),
}
